<template>
    <div>
        <vx-card :title="`Gérer la notation`">
            
            <div class="vx-row mb-6 mt-6">
                <div class="vx-col w-full">
                    <h4>Paramètres des {{ projectNames.plural }}</h4>
                </div>
            </div>

            <!-- COMPETENCES -->
            <div class="mb-10">
                <div class="vx-row mb-6">
                    <div class="vx-col w-full">
                        <h5>Compétences</h5>
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/5 w-full">
                        <span>Paramètre 1 :</span>
                    </div>
                    <div class="vx-col sm:w-1/5 w-full">
                        <vs-input
                            v-model="params[1].note"
                            name="param1Note"
                            type="number"
                            class="w-full"
                            label-placeholder="Note"
                        />
                    </div>
                    <div class="vx-col sm:w-2/5 w-full">
                        <vs-input
                            v-model="params[1].label"
                            name="param1Label"
                            class="w-full"
                            label-placeholder="Libellé de la note"
                        />
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/5 w-full">
                        <span>Paramètre 2 :</span>
                    </div>
                    <div class="vx-col sm:w-1/5 w-full">
                        <vs-input
                            v-model="params[2].note"
                            name="param2Note"
                            type="number"
                            class="w-full"
                            label-placeholder="Note"
                        />
                    </div>
                    <div class="vx-col sm:w-2/5 w-full">
                        <vs-input
                            v-model="params[2].label"
                            name="param2Label"
                            class="w-full"
                            label-placeholder="Libellé de la note"
                        />
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/5 w-full">
                        <span>Paramètre 3 :</span>
                    </div>
                    <div class="vx-col sm:w-1/5 w-full">
                        <vs-input
                            v-model="params[3].note"
                            name="param3Note"
                            type="number"
                            class="w-full"
                            label-placeholder="Note"
                        />
                    </div>
                    <div class="vx-col sm:w-2/5 w-full">
                        <vs-input
                            v-model="params[3].label"
                            name="param3Label"
                            class="w-full"
                            label-placeholder="Libellé de la note"
                        />
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/5 w-full">
                        <span>Paramètre 4 :</span>
                    </div>
                    <div class="vx-col sm:w-1/5 w-full">
                        <vs-input
                            v-model="params[4].note"
                            name="param4Note"
                            type="number"
                            class="w-full"
                            label-placeholder="Note"
                        />
                    </div>
                    <div class="vx-col sm:w-2/5 w-full">
                        <vs-input
                            v-model="params[4].label"
                            name="param4Label"
                            class="w-full"
                            label-placeholder="Libellé de la note"
                        />
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/5 w-full">
                        <span>Paramètre Non mesuré :</span>
                    </div>
                    <div class="vx-col sm:w-2/5 w-full">
                        <vs-input
                            v-model="NonMesuredLevel"
                            name="nonMesuredNote"
                            type="number"
                            class="w-full"
                            label-placeholder="Note"
                        />
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/5 w-full">
                        <span>Paramètre En cours :</span>
                    </div>
                    <div class="vx-col sm:w-2/5 w-full">
                        <vs-input
                            v-model="NonAcquiredLevel"
                            name="nonAcquiredNote"
                            type="number"
                            class="w-full"
                            label-placeholder="Note"
                        />
                    </div>
                </div>
            </div>

            <!-- SAVOIR FAIRE -->
            <div class="mb-10">
                <div class="vx-row mb-6">
                    <div class="vx-col w-full">
                        <h5>Savoir-faire</h5>
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/5 w-full">
                        <span>Paramètre 1 :</span>
                    </div>
                    <div class="vx-col sm:w-1/12 w-full">
                        <vs-input
                            v-model="paramsOccSkill[1].note"
                            name="param1Note"
                            type="number"
                            class="w-full"
                            label-placeholder="Note"
                        />
                    </div>
                    <div class="vx-col sm:w-2/12 w-full">
                        <vs-input
                            v-model="paramsOccSkill[1].label"
                            name="param1Label"
                            class="w-full"
                            label-placeholder="Libellé de la note"
                        />
                    </div>
                    <div class="vx-col sm:w-1/12 w-full">
                        <vs-input
                            v-model="paramsOccSkill[1].coef"
                            name="param1Coef"
                            type="number"
                            class="w-full"
                            label-placeholder="Coefficient"
                        />
                    </div>
                    <div class="vx-col sm:w-5/12 w-full">
                        <vs-input
                            v-model="paramsOccSkill[1].description"
                            name="param1Description"
                            class="w-full"
                            label-placeholder="Signification de la note par défaut"
                        />
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/5 w-full">
                        <span>Paramètre 2 :</span>
                    </div>
                    <div class="vx-col sm:w-1/12 w-full">
                        <vs-input
                            v-model="paramsOccSkill[2].note"
                            name="param2Note"
                            type="number"
                            class="w-full"
                            label-placeholder="Note"
                        />
                    </div>
                    <div class="vx-col sm:w-2/12 w-full">
                        <vs-input
                            v-model="paramsOccSkill[2].label"
                            name="param2Label"
                            class="w-full"
                            label-placeholder="Libellé de la note"
                        />
                    </div>
                    <div class="vx-col sm:w-1/12 w-full">
                        <vs-input
                            v-model="paramsOccSkill[2].coef"
                            name="param2Coef"
                            type="number"
                            class="w-full"
                            label-placeholder="Coefficient"
                        />
                    </div>
                    <div class="vx-col sm:w-5/12 w-full">
                        <vs-input
                            v-model="paramsOccSkill[2].description"
                            name="param2Description"
                            class="w-full"
                            label-placeholder="Signification de la note par défaut"
                        />
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/5 w-full">
                        <span>Paramètre 3 :</span>
                    </div>
                    <div class="vx-col sm:w-1/12 w-full">
                        <vs-input
                            v-model="paramsOccSkill[3].note"
                            name="param3Note"
                            type="number"
                            class="w-full"
                            label-placeholder="Note"
                        />
                    </div>
                    <div class="vx-col sm:w-2/12 w-full">
                        <vs-input
                            v-model="paramsOccSkill[3].label"
                            name="param3Label"
                            class="w-full"
                            label-placeholder="Libellé de la note"
                        />
                    </div>
                    <div class="vx-col sm:w-1/12 w-full">
                        <vs-input
                            v-model="paramsOccSkill[3].coef"
                            name="param3Coef"
                            type="number"
                            class="w-full"
                            label-placeholder="Coefficient"
                        />
                    </div>
                    <div class="vx-col sm:w-5/12 w-full">
                        <vs-input
                            v-model="paramsOccSkill[3].description"
                            name="param3Description"
                            class="w-full"
                            label-placeholder="Signification de la note par défaut"
                        />
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/5 w-full">
                        <span>Paramètre 4 :</span>
                    </div>
                    <div class="vx-col sm:w-1/12 w-full">
                        <vs-input
                            v-model="paramsOccSkill[4].note"
                            name="param4Note"
                            type="number"
                            class="w-full"
                            label-placeholder="Note"
                        />
                    </div>
                    <div class="vx-col sm:w-2/12 w-full">
                        <vs-input
                            v-model="paramsOccSkill[4].label"
                            name="param4Label"
                            class="w-full"
                            label-placeholder="Libellé de la note"
                        />
                    </div>
                    <div class="vx-col sm:w-1/12 w-full">
                        <vs-input
                            v-model="paramsOccSkill[4].coef"
                            name="param4Coef"
                            type="number"
                            class="w-full"
                            label-placeholder="Coefficient"
                        />
                    </div>
                    <div class="vx-col sm:w-5/12 w-full">
                        <vs-input
                            v-model="paramsOccSkill[4].description"
                            name="param4Description"
                            class="w-full"
                            label-placeholder="Signification de la note par défaut"
                        />
                    </div>
                </div>
            </div>
          
            <!-- ACCESSIBILITÉ -->
            <div class="mb-10">
                <div class="vx-row mb-6">
                    <div class="vx-col w-full">
                        <h4>Paramètres de l'accessibilité</h4>
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/5 w-full">
                        <span>Paramètre Requis :</span>
                    </div>
                    <div class="vx-col sm:w-1/5 w-full">
                        <vs-input
                            v-model="RequiredLevel.note"
                            name="requiredLevelNote"
                            type="number"
                            class="w-full"
                            label-placeholder="Note"
                        />
                    </div>
                    <div class="vx-col sm:w-1/5 w-full">
                        <vs-input
                            v-model="RequiredLevel.coef"
                            name="requiredLevelCoef"
                            type="number"
                            class="w-full"
                            label-placeholder="Coefficient"
                        />
                    </div>
                    <div class="vx-col sm:w-2/5 w-full">
                        <vs-input
                            v-model="RequiredLevel.label"
                            name="requiredLevelLabel"
                            class="w-full"
                            label-placeholder="Libellé de la note"
                        />
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/5 w-full">
                        <span>Paramètre Indispensable :</span>
                    </div>
                    <div class="vx-col sm:w-1/5 w-full">
                        <vs-input
                            v-model="IndispensableLevel.note"
                            name="indispensableLevelNote"
                            type="number"
                            class="w-full"
                            label-placeholder="Note"
                        />
                    </div>
                    <div class="vx-col sm:w-1/5 w-full">
                        <vs-input
                            v-model="IndispensableLevel.coef"
                            name="indispensableLevelCoef"
                            type="number"
                            class="w-full"
                            label-placeholder="Coefficient"
                        />
                    </div>
                    <div class="vx-col sm:w-2/5 w-full">
                        <vs-input
                            v-model="IndispensableLevel.label"
                            name="indispensableLevelLabel"
                            class="w-full"
                            label-placeholder="Libellé de la note"
                        />
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/5 w-full">
                        <span>Paramètre Autonomie :</span>
                    </div>
                    <div class="vx-col sm:w-1/5 w-full">
                        <vs-input
                            v-model="AutonomyLevel.note"
                            name="autonomyLevelNote"
                            class="w-full"
                            type="number"
                            label-placeholder="Note"
                        />
                    </div>
                    <div class="vx-col sm:w-1/5 w-full">
                        <vs-input
                            v-model="AutonomyLevel.coef"
                            name="autonomyLevelCoef"
                            class="w-full"
                            type="number"
                            label-placeholder="Coefficient"
                        />
                    </div>
                    <div class="vx-col sm:w-2/5 w-full">
                        <vs-input
                            v-model="AutonomyLevel.label"
                            name="autonomyLevelLabel"
                            class="w-full"
                            label-placeholder="Libellé de la note"
                        />
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/5 w-full">
                        <span>Paramètre Centre-Radar :</span>
                    </div>
                    <div class="vx-col sm:w-2/5 w-full">
                        <vs-input
                            v-model="RadarCenter"
                            name="radarCenter"
                            type="number"
                            class="w-full"
                        />
                    </div>
                </div>
            </div>

            <!-- Signification -->
            <!-- <div class="vx-row mb-6 mt-20">
                <div class="vx-col w-full">
                    <h4>Signification des notes des savoir-faire par défaut : </h4>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                    <b>0 - Non mesuré :</b>
                </div>
                <div class="vx-col sm:w-2/5 w-full">
                    <vs-input
                        v-model="meaningNotes[0]"
                        name="meaningNotes_0"
                        class="w-full"
                    />
                </div>
            </div>

            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                    <b>1 - En cours :</b>
                </div>
                <div class="vx-col sm:w-2/5 w-full">
                    <vs-input
                        v-model="meaningNotes[1]"
                        name="meaningNotes_1"
                        class="w-full"
                    />
                </div>
            </div>

            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                    <b>2 - Acquis :</b>
                </div>
                <div class="vx-col sm:w-2/5 w-full">
                    <vs-input
                        v-model="meaningNotes[2]"
                        name="meaningNotes_2"
                        class="w-full"
                    />
                </div>
            </div>

            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                    <b>3 - Autonomie :</b>
                </div>
                <div class="vx-col sm:w-2/5 w-full">
                    <vs-input
                        v-model="meaningNotes[3]"
                        name="meaningNotes_3"
                        class="w-full"
                    />
                </div>
            </div> -->


            

            <div class="vx-row">
                <div class="vx-col w-full">
                    <vs-button class="mr-3 mb-2" @click="setRatingSettings()">
                        Enregistrer
                    </vs-button>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>
export default {
    name: "Parameters",
    data() {
        return {
            params: {
                1: {
                    note: "0",
                    label: "Non mesuré"
                },
                2: {
                    note: "1",
                    label: "En cours"
                },
                3: {
                    note: "2",
                    label: "Acquis"
                },
                4: {
                    note: "3",
                    label: "Autonomie"
                }
            },
            paramsOccSkill: {
                1: {
                    note: "0",
                    label: "Non mesuré",
                    coef: "0",
                    description: "Le savoir-faire n'est pas évalué"
                },
                2: {
                    note: "1",
                    label: "En cours",
                    coef: "1",
                    description: "Le savoir-faire n'est pas ou peu maitrisé"
                },
                3: {
                    note: "2",
                    label: "Acquis",
                    coef: "2",
                    description: "Le savoir-faire est maitrisé avec l'aide de l'encadrant"
                },
                4: {
                    note: "3",
                    label: "Autonomie",
                    coef: "3",
                    description: "Le savoir-faire est maitrisé sans l'aide d'un encradrant mais un gabarit, un modèle... peut être mis en place"
                }
            },
            NonMesuredLevel: "0",
            NonAcquiredLevel: "1",
            RequiredLevel: {
                id: "1",
                note: "2",
                coef: "1",
                label: "Requis"
            },
            IndispensableLevel: {
                id: "2",
                note: "2",
                coef: "2",
                label: "Indispensable"
            },
            AutonomyLevel: {
                id: "3",
                note: "3",
                coef: "3",
                label: "Indispensable en autonomie"
            },
            // meaningNotes: {
            //     0: "Le savoir-faire n'est pas évalué",
            //     1: "Le savoir-faire n'est pas ou peu maitrisé",
            //     2: "Le savoir-faire est maitrisé avec l'aide de l'encadrant",
            //     3: "Le savoir-faire est maitrisé sans l'aide d'un encradrant mais un gabarit, un modèle... peut être mis en place"
            // },
            RadarCenter: -1,
            loading: false
        };
    },
    computed: {
        ratingSettings() {
            return window.Laravel.settings.find(el => el.name == "ratings")
                .value;
        },
        paramOptions() {
            return [...Object.keys(this.params)].map(i => {
                return {
                    ...this.params[i],
                    param: `Paramètre ${i}`,
                    index: i
                };
            });
        }
    },
    watch: {
        ratingSettings(newValue) {
            if (newValue.params !== undefined) {
                this.setValues();
            }
        },
        loading(newValue) {
            if (newValue) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        }
    },
    mounted() {
        if (this.ratingSettings.params !== undefined) {
            this.setValues();
        }
    },
    methods: {
        setValues() {
            this.params = this.ratingSettings.params;
            this.NonMesuredLevel = this.ratingSettings.NonMesuredLevel;
            this.NonAcquiredLevel = this.ratingSettings.NonAcquiredLevel;
            this.RequiredLevel = this.ratingSettings.RequiredLevel;
            this.IndispensableLevel = this.ratingSettings.IndispensableLevel;
            this.AutonomyLevel = this.ratingSettings.AutonomyLevel;
            this.RadarCenter = this.ratingSettings.RadarCenter;
            
            if (this.ratingSettings.paramsOccSkill) {
                Object.assign(this.paramsOccSkill, this.ratingSettings.paramsOccSkill);
            }

            if (this.ratingSettings.meaningNotes) {
                this.meaningNotes = this.ratingSettings.meaningNotes;
            }

            
        },
        setRatingSettings() {
            this.loading = true;

            let data = {
                params: this.params,
                paramsOccSkill: this.paramsOccSkill,
                RequiredLevel: this.RequiredLevel,
                IndispensableLevel: this.IndispensableLevel,
                AutonomyLevel: this.AutonomyLevel,
                NonAcquiredLevel: this.NonAcquiredLevel,
                NonMesuredLevel: this.NonMesuredLevel !== "" ? this.NonMesuredLevel : null,
                RadarCenter: this.RadarCenter,
                meaningNotes: this.meaningNotes
            };

            window.axios({
                method: 'patch',
                url: `/api/referentiel/settings/rating`,
                data: data
            })
            .then(response => {

                if (response.status === 200 && response.data != '') {
                    this.notifySuccess('Succès', 'Élement modifié avec succès !')
                } else {

                    this.notifyError('Erreur', `Une erreur est survenue lors de la modification`)
                }

                this.loading = false;
            })
            .catch((err, data) => {
                this.notifyErrorValidation(err)
                if (callbackError) {
                    callbackError(err.response)
                }
            })
        }
    }
};
</script>

<style lang="scss" scoped></style>
